import React, { useState, useRef } from 'react';
import {Form, Button, Card} from 'react-bootstrap'
import axios from 'axios';
import OverLay from '../overlay';
import Popup from 'reactjs-popup';
import {useHistory} from 'react-router-dom';
import LoginByModal from './login_by_modal'

const Notary=(props)=>{
    const history=useHistory()
    const [loginornot, setloginornot]=useState(false)

    const [noterydata, setnotarydata]=useState({
        notaryType:'',
        uploadedDoc:{},
        payment_method:''
    })
    const [err, seterr]=useState({})
    const popupmodal=useRef()

    const [getrequestdata, setgetrequestdata]=useState({})
    const [indicator, setindecator]=useState(false)
    const onhandlesubmit=()=>{
        let err={}
        if(noterydata.notaryType===''){
            err['notaryType']='Please Select Notery Type'
        }
        if(noterydata.notaryType==='True Copy Notary'){
            if(Object.keys(noterydata.uploadedDoc).length===0){
                err['uploadedDoc']='Please Upload scan copy'
            }
        }
        if(noterydata.payment_method===''){
            err['payment_method']='Please Choose payment method'
        }
        seterr(err)
        if(Object.keys(err).length===0){
            setindecator(true)
            axios.post('/save_notary_service', {
                data:noterydata,
                user_id:props.userData.id,
                scheme_id:props.userData.corporate_id

            }).then((res)=>{
                setindecator(false)
                setgetrequestdata(res.data)
    
                popupmodal.current.open()
            })
        }
    }
    console.log(props)
    return(
        <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
            <div style={{
                width:300
            }}>
                <div>
                    <label>Select Notary Type</label>
                </div>
                <div>
                    <select className='form-select' value={noterydata.notaryType} onChange={(ev)=>{
                        setnotarydata({...noterydata, notaryType:ev.target.value, uploadedDoc:{}})
                        let nerr={...err}
                                nerr['notaryType']=''
                                seterr({...nerr})
                    }}>
                        <option key='-1' value=''>Select Notary Type</option>
                        <option key='0' value='True Copy Notary'>True Copy Notary</option>
                        <option key='1' value='Scanned copy is fine'>Register Copy Notary</option>
                    </select>
                </div>
                {err['notaryType']&&
                    <div>
                        <span style={{color:'red'}}>{err['notaryType']}</span>
                    </div>
                }
            </div>
            {noterydata.notaryType==='True Copy Notary'&&
                <div  style={{
                    width:300,
                    paddingTop:10

                }}>
                    <div>
                        <label>Scanned copy is fine</label>
                    </div>
                    <div>
                        <input type='file' multiple onChange={(ev)=>{
                            let totalfile={}
                            var files = ev.target.files
                            for(let i=0;i<files.length;i++){
                                var file=files[i]
                                var reader = new FileReader();
                                reader.onload=(resu)=>{
                                    totalfile['files_'+i]={data:resu.target.result, type:file.type}
                                }
                                reader.readAsDataURL(file)
                            }
                        setnotarydata({...noterydata, uploadedDoc:totalfile})

                            let nerr={...err}
                            nerr['uploadedDoc']=''
                            seterr({...nerr})
                        }}/>
                    </div>
                    {err['uploadedDoc']&&
                        <div>
                            <span style={{color:'red'}}>{err['uploadedDoc']}</span>
                        </div>
                    }
                </div>
            }
            {noterydata.notaryType==='Scanned copy is fine'&&
                <div  style={{
                    width:300,
                    paddingTop:10
                }}>
                   <span>Required Hard Copy</span>
                </div>
            }
            <div>
                <label>Payment Method:</label>
                    <div style={{width:300, justifyContent:'space-between', display:'flex'}}>
                        <span>
                            <input value='Prepaid' onChange={(ev)=>{
                                setnotarydata({...noterydata, payment_method:ev.target.value})
                                let nerr={...err}
                                nerr['payment_method']=''
                                seterr({...nerr})
                            }} type="radio" name="payment_method" aria-label="payment_method"/>
                            <br/>
                            Prepaid 
                        </span>
                        <span>
                            <input value='Post Paid' onChange={(ev)=>{
                                setnotarydata({...noterydata, payment_method:ev.target.value})
                                let nerr={...err}
                                nerr['payment_method']=''
                                seterr({...nerr})
                            }} type="radio" name="payment_method" aria-label="payment_method"/>
                            <br/>
                            Post Paid 
                        </span>
                        <span>
                            <input value='Wallet' type="radio" onChange={(ev)=>{
                                setnotarydata({...noterydata, payment_method:ev.target.value})
                                let nerr={...err}
                                nerr['payment_method']=''
                                seterr({...nerr})
                            }} name="payment_method" aria-label="payment_method"/>
                            <br/>
                            Wallet
                        </span>
                    </div>
                    {err['payment_method']&&
                        <div>
                            <span style={{color:'red'}}>{err['payment_method']}</span>
                        </div>
                    }
                </div>
            <div>
                <div style={{textAlign:'center', width:'100%', paddingTop:20}}>
                   {Object.keys(props.userData).length===0?
                    <Button  variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}}
                    onClick={(()=>{
                        setloginornot(true)
                    })}
                    >Login</Button>
                    
                    :
                    <Button type="submit"  onClick={()=>{
                        onhandlesubmit()
                    }} variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}} >Submit</Button>
                    }                </div>
            </div>
            <Popup
    ref={popupmodal}
    // trigger={<button className="button"> Open Modal </button>}
    modal
    nested>
    {close => (
        <div>
            {getrequestdata.message&&
                <h6 style={{
                    padding:33,
                    color:'blueviolet'
                }}>Created with Request ID {getrequestdata.text}</h6>
            }
          <div style={{display:'flex',alignItems:'center', justifyContent:'space-around'}}>
                <Button onClick={()=>{
                    close()
                    setnotarydata({
                        notaryType:'',
                        uploadedDoc:{},
                        payment_method:''
                    })
                }}>Continue</Button>
                <Button onClick={()=>{
                    history.push('/reports')
                    history.go(0)
                }}>Go To The Reports</Button>
            </div>
        </div>
      )}
   
</Popup>
    <OverLay active={indicator}/>
    <LoginByModal loginClick={loginornot} propsStateData={noterydata} login_not={true} closeModal={(ev)=>{
        console.log('props', props)
        setloginornot(false)
    }}/>
        </div>
    )
}
export default Notary;